module.exports = __webpack_public_path__ + "img/ghost-mobile.c0c60adf.png";